import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { KintipsAvatarComponent } from './kintips-avatar';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    KintipsAvatarComponent,
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild()
  ],
  exports: [
    KintipsAvatarComponent
  ]
})
export class KintipsAvatarComponentModule {}



// WEBPACK FOOTER //
// ./src/components/kintips-avatar/kintips-avatar.module.ts